/**
 * Layout simplificado para usuarios con rol 'coach' (entrenadores)
 *
 * Solo maneja:
 * - Carga de datos del entrenador
 * - Contexto compartido para las páginas hijas
 * - El header y navegación se manejan en App.js
 */

import { useState, useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

const CoachLayout = () => {
  const [coachData, setCoachData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Memoizar el contexto para evitar re-renderizados innecesarios
  const contextValue = useMemo(() => ({
    coachData,
    setCoachData
  }), [coachData]);

  // Cargar datos del entrenador
  useEffect(() => {
    const fetchCoachData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('prokids_token');

        const response = await fetch('/api/coach/dashboard', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const result = await response.json();
          if (result.success) {
            setCoachData(result.data);
          }
        } else {
          console.error('❌ Error en la respuesta:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error al cargar datos del entrenador:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCoachData();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
        backgroundColor: '#F5F5F5'
      }}>
        <div style={{
          textAlign: 'center',
          color: '#4352A9'
        }}>
          <div style={{
            fontSize: '2rem',
            marginBottom: '10px'
          }}>🏃‍♂️</div>
          <p>Cargando datos del entrenador...</p>
        </div>
      </div>
    );
  }

  return <Outlet context={contextValue} />;
};

export default CoachLayout;
